// Sürücü Puantajı — basit çubuk sparkline (trend).
// SVG kullanır; harici grafik kütüphanesine bağımlılık yok.
// showValues=true iken her çubuğun üzerine değer yazılır (detay görünümü).
// showDateLabels=true iken her çubuğun altına MM-DD tarih etiketi yazılır.

import React, { useMemo } from "react";

import { axisDate } from "../utils";

const PerformanceTrend = ({
  series = [],
  metric = "count",
  width = 160,
  height = 36,
  color = "#1976d2",
  showValues = false,
  showDateLabels = false,
}) => {
  const values = useMemo(() => series.map((d) => Number(d?.[metric]) || 0), [series, metric]);
  const max = useMemo(() => Math.max(1, ...values), [values]);

  if (!series.length) return <span className="dp-trend dp-trend--empty">—</span>;

  const n = values.length;
  const gap = showValues || showDateLabels ? 2 : 1;
  const topLabelSpace = showValues ? 14 : 0;
  const bottomLabelSpace = showDateLabels ? 12 : 0;
  const chartHeight = height - topLabelSpace - bottomLabelSpace;
  const barWidth = Math.max(1, (width - (n - 1) * gap) / n);

  return (
    <svg className="dp-trend" width={width} height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
      {values.map((v, i) => {
        const h = max > 0 ? (v / max) * (chartHeight - 2) : 0;
        const x = i * (barWidth + gap);
        const barH = Math.max(v > 0 ? 1 : 0, h);
        const y = topLabelSpace + (chartHeight - barH);
        const cx = x + barWidth / 2;
        return (
          <g key={i}>
            <rect x={x} y={y} width={barWidth} height={barH} rx={0.5} fill={color} opacity={v > 0 ? 0.85 : 0.15} />
            {showValues && (
              <text x={cx} y={v > 0 ? y - 2 : topLabelSpace + chartHeight - 2} textAnchor="middle" fontSize="9" fill="#555">
                {v}
              </text>
            )}
            {showDateLabels && series[i]?.date && (
              <text x={cx} y={height - 1} textAnchor="middle" fontSize="7" fill="#888">
                {axisDate(series[i].date)}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
};

export default PerformanceTrend;
